import { useEffect, useRef, useState } from 'react'
import { api, ErrorDeApi } from '../servicios/api'
import { nombreDePeriodo } from '../periodos'

/**
 * RF-1607 · Descarga en un ZIP todo lo que el cliente tiene pendiente de presentar en el periodo: los archivos
 * del Anexo 24 sin enviar o rechazados, los papeles de las declaraciones sin presentar y un LEEME con la guía de
 * cada uno. Si no hay nada pendiente el servidor responde NADA_PENDIENTE_DE_PRESENTAR con el porqué, y se muestra
 * tal cual: puede ser que todo ya se presentó o que todavía no se genera nada, y no es lo mismo.
 */
export function PaqueteDePresentacion({ clienteId, anio, mes }: { clienteId: string; anio: number; mes: number }) {
  const [generando, setGenerando] = useState(false)
  const [error, setError] = useState('')

  // El error de una descarga de otro mes ya no es de esta pantalla.
  const periodoVigente = useRef(`${clienteId}-${anio}-${mes}`)

  useEffect(() => {
    periodoVigente.current = `${clienteId}-${anio}-${mes}`
    setError('')
  }, [clienteId, anio, mes])

  async function descargar() {
    const periodo = periodoVigente.current
    setGenerando(true)
    setError('')
    try {
      await api.descargarPaqueteDePresentacion(clienteId, anio, mes)
    } catch (e) {
      if (periodoVigente.current === periodo)
        setError(e instanceof ErrorDeApi ? e.message : 'No se pudo generar el paquete de presentación.')
    } finally {
      setGenerando(false)
    }
  }

  return (
    <p className="filtros">
      <button type="button" className="secundario" disabled={generando} onClick={() => void descargar()}>
        {generando ? 'Generando…' : `Paquete de presentación de ${nombreDePeriodo(anio, mes)}`}
      </button>
      <span className="sutil">
        Lo que falta presentar del mes en un ZIP: archivos del Anexo 24, papeles de las declaraciones y la guía de cada uno.
      </span>
      {error && <span className="error" role="alert">{error}</span>}
    </p>
  )
}
